import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {useSearchParams} from "react-router-dom";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import Pagination from "react-js-pagination";

export default function Experts(prop) {
    let [searchParams] = useSearchParams();

    let [listing, setListing] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);

    let refKeyword = React.useRef();

    React.useEffect(() => {
        if(searchParams.get('keyword')) {
            refKeyword.current.value = searchParams.get('keyword');
        }
        else {
            refKeyword.current.value = '';
        }

        (async function() {
            try {
                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
                }
            } catch (e) {
                //
            }
        })();
    }, [itemPerpage]);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        const response = await fetch(Config.apiUrl +'experts/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                keyword: refKeyword.current.value,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onSearch = (e) => {
        let param = [];
        if(refKeyword.current.value) {
            param.push('keyword=' + refKeyword.current.value);
        }

        window.location = (prop.lang === 'en' ? '/en': '/') + 'experts' + (param.length > 0 ? '?' + param.join('&') : '');
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && refKeyword.current.value) {
            onSearch()
        }
    };

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'Experts':'ข้อมูลผู้เชี่ยวชาญ'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Experts':'ข้อมูลผู้เชี่ยวชาญ'}</span>
                    </h1>
                </div>
            </div>

            <div className="section bg-light">
                <div className="container">
                    <div className="hgroup hgroup-search" data-aos="fade-in">
                        <h2 className="text-center text-primary">{prop.lang === 'en' ? 'Experts':'ข้อมูลผู้เชี่ยวชาญ'}</h2>
                        <div className="d-flex flex-wrap pt-3">
                            <div className="show-list">
                                <p>แสดงรายการ</p>
                                <select className="form-select" onChange={e => setItemPerpage(parseInt(e.target.value))}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                    <option value={40}>40</option>
                                    <option value={50}>50</option>
                                </select>
                                <p>แถว</p>
                            </div>

                            <div className="form-group search">
                                <input type="text" className="form-control" placeholder="ค้นหา" maxLength={50} ref={refKeyword} onKeyDown={handleKeyDown} />
                                <button className="btn btn-secondary" type="button" onClick={onSearch}>ค้นหา</button>
                            </div>
                        </div>
                    </div>

                    <div className="row g-3 pt-md-3 pt-3">
                        {
                            listing !== null && listing.count > 0 ?
                                <>
                                    {
                                        listing.rows.map((row, index) => {
                                            return (
                                                <div key={index} className="col-12">
                                                    <div className="card-infos" data-aos="fade-in">
                                                        <div className="row gy-2 gx-4">
                                                            <div className="col-12">
                                                                <h3 className="fs-20"><a href={(prop.lang === 'en' ? '/en':'') + '/experts/detail/' + row.slug}>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</a></h3>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <ul className="infos-list">
                                                                    <li>
                                                                        <h6>{prop.lang === 'en' ? 'Department':'สังกัด'} :</h6>
                                                                        <p>{row.department ?? '-'}</p>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <ul className="infos-list">
                                                                    <li>
                                                                        <h6>{prop.lang === 'en' ? 'Expertise':'ความเชี่ยวชาญ'} :</h6>
                                                                        <p>{row.expertise ?? '-'}</p>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </> : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                        }
                    </div>

                    <div className={totalPage > 1 ? '':'d-none'}>
                        <Pagination
                            itemClassPrev="arrow prev"
                            itemClassNext="arrow next"
                            activeClass="active"
                            itemClass=""
                            linkClass=""
                            innerClass="pagination"
                            activePage={activePage}
                            itemsCountPerPage={itemPerpage}
                            totalItemsCount={countAllItem}
                            pageRangeDisplayed={5}
                            onChange={(pageNum) => onPageChange(pageNum)}
                        />
                    </div>

                    <div className="p-3"></div>
                </div>
            </div>
        </>
    );
} 